import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    categories: [],
    loadingStatus: "idle",
    error: null
}

export const fetchUpdateFields = createAsyncThunk(
    'fieldsUpdateList/fetchUpdateFields',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/reports/updates/create`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error.status)
        }
    }
)

const fieldUpdateListSlice = createSlice({
    name: 'fieldUpdateList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUpdateFields.pending, (state) => {
                state.categories = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchUpdateFields.fulfilled, (state, action) => {
                state.categories = action.payload?.categories || [];
                state.loadingStatus = "idle";
                state.error = null
            })
            .addCase(fetchUpdateFields.rejected, (state, action) => {
                state.categories = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default fieldUpdateListSlice.reducer;